export const versions = {
    designToken: 7,
    ads: 555,
    smartSlots: 4,
};
//# sourceMappingURL=index.js.map